import { useMapContext } from '@components/map/MapContext';
import { createSensorLayerErrorToast } from '@components/ui/toaster/toaster';
import { useAppSelector } from '@hooks/redux.hooks';
import { useSelectorWithReplayMode } from '@hooks/useSelectorWithReplayMode';
import { hasSensorRoleFromActiveProfile } from '@redux/authent/authent.selectors';
import { selectNeutralSectorsFeatureCollection } from '@redux/mapDisplay/mapDisplay.selectors';
import { isFeatureCollection } from '@utils/map/map.utils';
import { ErrorBoundary } from 'react-error-boundary';
import { Layer, Source } from 'react-map-gl/mapbox';

import { ActionEnum } from '@/types/commons/commons.types';
import { MapIdEnum, SourceNameEnum } from '@/types/map.types';
import { SensorFamilyEnum } from '@/types/sensor/sensor.types';

import { neutralSectorFill, neutralSectorOutlines, neutralSectorStripes } from './neutral.layer';

function NeutralSectorsLayerContent() {
  const featureCollection = useSelectorWithReplayMode(selectNeutralSectorsFeatureCollection);
  const neutralSensorActionCommand = { action: ActionEnum.ACCESS, sensorFamily: SensorFamilyEnum.NEUTRAL };
  const accessNeutral = useAppSelector((state) => hasSensorRoleFromActiveProfile(state, neutralSensorActionCommand));

  if (!isFeatureCollection(featureCollection) || !accessNeutral) return null;

  return (
    <Source id={SourceNameEnum.NEUTRAL_SECTORS} type="geojson" data={featureCollection}>
      <Layer {...neutralSectorStripes} />
      <Layer {...neutralSectorFill} />
      <Layer {...neutralSectorOutlines} />
    </Source>
  );
}

export default function NeutralSectorsLayer() {
  const { mapId } = useMapContext();
  return mapId === MapIdEnum.REPLAY ? (
    <ErrorBoundary fallback={<></>} onError={() => createSensorLayerErrorToast(SourceNameEnum.NEUTRAL_SECTORS)}>
      <NeutralSectorsLayerContent />
    </ErrorBoundary>
  ) : (
    <NeutralSectorsLayerContent />
  );
}
